var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-wrap",style:({
        width: _vm.isCollapse ? '64px' : '200px',
        height: _vm.isCollapse ? '40px' : '40px',
    })},[_c('i',{staticClass:"iconfont icon-tuodong",on:{"click":_vm.handleChangeCollapse}}),(!this.isCollapse)?[_c('span',{staticClass:"title"},[_vm._v("Milewsys OA")]),_c('span',{staticClass:"version"},[_vm._v("1.0")])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }